import React from 'react'

import Layout from '../App/layout'
import ContentLayout from '../../components/utility/layoutContent'
import LayoutContentWrapper from '../../components/utility/layoutWrapper'

import SupplierOrderIndexContainer from './NewSupplierOrderIndexContainer'

class SupplierOrderIndexPage extends React.Component {
    componentDidMount() {
        document.title = 'Supplier Orders | OSH CRM'
    }

    render () {
        return (
            <Layout>
                <LayoutContentWrapper breadcrumbs={[
                        { path: '/supplier_orders', name: 'Supplier Orders' }
                    ]}>
                    <ContentLayout>
                        <SupplierOrderIndexContainer />
                    </ContentLayout>
                </LayoutContentWrapper>
            </Layout>
        )
    }
}

export default SupplierOrderIndexPage
